export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";